import { render, staticRenderFns } from "./TraceyAiComposer.vue?vue&type=template&id=715dbcb1&scoped=true"
import script from "./TraceyAiComposer.vue?vue&type=script&lang=js"
export * from "./TraceyAiComposer.vue?vue&type=script&lang=js"
import style0 from "./TraceyAiComposer.vue?vue&type=style&index=0&id=715dbcb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715dbcb1",
  null
  
)

export default component.exports